  $(document).ready(function(){
    function updateHeaderHeight() {
      let headerHeight = $('.new-header__wrapper').outerHeight();
      $('.new-header').css({'height':`${headerHeight}px`});
      $('.new-header__mobile-menu').css({'max-height': `calc(100vh - ${headerHeight}px)`})
      $('.PageContainer').addClass('m-loaded');
    }

    function initializeMegamenuTabindex() {
      $('.header__megamenu-item:not(.active) a').attr('tabindex', '-1');
      $('.header__megamenu-item.active a').attr('tabindex', '0');
    }

    function updateMegamenuTabindex(dataId, isActive) {
      if (isActive) {
        $(`.header__megamenu-item[data-id="${dataId}"] a`).attr('tabindex', '0');
      } else {
        $(`.header__megamenu-item[data-id="${dataId}"] a`).attr('tabindex', '-1');
      }
    }

    $(window).resize(function(){
      updateHeaderHeight();
    });

    $(document).on('click', '.hamburger-wrapper', function() {
      $('.new-header__mobile-menu').toggleClass('active');
      $('.new-header-v4 .new-header__wrapper').removeClass('mob-active');
      $('body').toggleClass('m-fixed');
    });

    updateHeaderHeight();
    initializeMegamenuTabindex();

    $('.m-sub-wrap').hover(
      function() {
        $(this).find('.m-submenu').addClass('m-submenu-active');
        $(this).find('.menu-link').attr('aria-expanded', 'true');
      },
      function() {
        $(this).find('.m-submenu').removeClass('m-submenu-active');
        $(this).find('.menu-link').attr('aria-expanded', 'false');
      }
    );

    $(document).on('click', '.m-sub-wrap .menu-link', function(e) {
      const $submenu = $(this).siblings('.m-submenu');
      const isActive = $submenu.hasClass('m-submenu-active');
      
      if (isActive) {
        $submenu.removeClass('m-submenu-active');
        $(this).attr('aria-expanded', 'false');
      } else {
        $submenu.addClass('m-submenu-active');
        $(this).attr('aria-expanded', 'true');
      }
    });

    $(document).on('keydown', '.m-sub-wrap .menu-link', function(e) {
      const keyCode = e.which || e.keyCode;
      
      if (keyCode === 13 || keyCode === 32) {
        e.preventDefault();
        $(this).click();
      }
    });

    $(document).on('click', '.new-header .hamburger-wrapper', function() {
      if ($(this).hasClass('active')) {
        if($(window).width() < 750) {
          setTimeout(function() {
            $('.hamburer-line.top-bun').css('transform', 'translate3d(0px, 1px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(45deg) skew(0deg, 0deg)');
            $('.hamburer-line.bottom-bun').css('transform', 'translate3d(0px, -1px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(-45deg) skew(0deg, 0deg)');
          },100);
          $('.header__menu__links.m-mob').removeClass('m-show-mega');
          $(`.new-header__mobile-menu .header__megamenu-item`).removeClass('m-active');
          $('.new-header-v4 .new-header__wrapper').removeClass('mob-active');
        }
        
      }
    });

    $(document).on('click', '.has-megamenu', function(e) {
      if ($(window).width() < 750) {
        e.preventDefault();
      }
    });

    $(document).on('click', '.header__menu__links.m-mob .has-megamenu', function(e) {
      e.preventDefault();
      let dataId = $(this).attr('data-id');
      $('.header__menu__links.m-mob').addClass('m-show-mega');
      $(`.new-header__mobile-menu .header__megamenu-item[data-id="${dataId}"]`).addClass('m-active');
      $('.new-header-v4 .new-header__wrapper').addClass('mob-active');
    });

    $(document).on('click', '.header__menu__links.m-mob .header__menu__links-back', function(e) {
      $('.header__menu__links.m-mob').removeClass('m-show-mega');
      $(`.new-header__mobile-menu .header__megamenu-item`).removeClass('m-active');
      $('.new-header-v4 .new-header__wrapper').removeClass('mob-active');
    });

    $(document).on('keydown', '.has-megamenu', function(e) {
      const keyCode = e.which || e.keyCode;
      
      if (keyCode === 13 || keyCode === 32) {
        e.preventDefault();
        const dataId = $(this).attr('data-id');
        const isActive = $(this).hasClass('active');
        
        if (!isActive) {
          $(this).addClass('active').attr('aria-expanded', 'true');
          $(`.header__megamenu-item[data-id="${dataId}"]`).addClass('active');
          $('.new-header-v4 .new-header__wrapper').addClass('active');
          updateMegamenuTabindex(dataId, true);
          
          setTimeout(() => {
            const firstFocusable = $(`.header__megamenu-item[data-id="${dataId}"]`).find('a').first();
            if (firstFocusable.length) {
              firstFocusable.focus();
            }
          }, 50);
        } else {
          $(this).removeClass('active').attr('aria-expanded', 'false');
          $(`.header__megamenu-item[data-id="${dataId}"]`).removeClass('active');
          $('.new-header-v4 .new-header__wrapper').removeClass('active');
          updateMegamenuTabindex(dataId, false);
        }
      }
      
      if (keyCode === 27) {
        const dataId = $(this).attr('data-id');
        $(this).removeClass('active').attr('aria-expanded', 'false');
        $(`.header__megamenu-item[data-id="${dataId}"]`).removeClass('active');
        $('.new-header-v4 .new-header__wrapper').removeClass('active');
        updateMegamenuTabindex(dataId, false);
        $(this).focus();
      }
    });

    $(document).on('keydown', '.header__megamenu-item', function(e) {
      if (e.which === 27 || e.keyCode === 27) {
        const dataId = $(this).attr('data-id');
        const trigger = $(`.has-megamenu[data-id="${dataId}"]`);
        
        trigger.removeClass('active').attr('aria-expanded', 'false');
        $(this).removeClass('active');
        $('.new-header-v4 .new-header__wrapper').removeClass('active');
        updateMegamenuTabindex(dataId, false);
        trigger.focus();
      }
    });

    $('.has-megamenu').hover(
        function () {
          let dataId = $(this).attr('data-id');
          $(this).addClass('active');
          $(this).attr('aria-expanded', 'true');
          $(`.header__megamenu-item[data-id="${dataId}"]`).addClass('active');
          $('.new-header-v4 .new-header__wrapper').addClass('active');
          updateMegamenuTabindex(dataId, true);
        }
    );

    $(document).on('mouseleave', '.new-header__wrapper.active .header', function (e) {
      setTimeout(function () {
        if (
          !$('.has-megamenu.active:hover').length &&
          !$('.header__megamenu-item.active:hover').length
        ) {
          $('.has-megamenu.active').each(function() {
            const activeDataId = $(this).attr('data-id');
            updateMegamenuTabindex(activeDataId, false);
          });
          $('.has-megamenu.active').removeClass('active').attr('aria-expanded', 'false');
          $('.header__megamenu-item.active').removeClass('active');
          $('.new-header-v4 .new-header__wrapper').removeClass('active');
        }
      }, 200);
    });
  });
